import React from 'react';
import {
    Text,
    Link,
    Box,
    VStack,
    Heading,
    UnorderedList,
    ListItem
} from '@chakra-ui/react';

export const FAQ = () => {
  const contact = {
    heading: "Contact us at:",
    address: "1503 S Watkins Road Watkins, CO 80137",
    phoneOne: "Clubhouse: 303-366-6970",
    phoneTwo: "Range Info Line: 303-512-9742",
    email: "info@goldengunclub.com"
  };

  return (
    <Box>
      <Heading as="h3" size="md" mb={3} color="black">Is Golden Gun Club open to the public?</Heading>
      <Text mb={6} color="black">
        Matches are open to the public as stated on the match description pages, however general activity on the range is restricted to members only. Club members are allowed to host 2 guests per session, however each guest must sign a waiver, and pay a $5 fee due to the Clubhouse prior to entering the range facilities.
      </Text>

      <Heading as="h2" size="md" mb={3} color="black">What calibers and weapons are allowed at Golden Gun Club?</Heading>
      <Text mb={4} color="black">
        Rifles and pistols of most calibers are allowed on the Rifle/Pistol line; however, 50BMG and 416 Barrett calibers are not allowed at Golden Gun Club for the safety of our neighbors beyond the range boundaries. If you have a question about your particular weapon, please contact a Club representative PRIOR TO bringing the weapon to the range.
      </Text>
      <Text mb={6} color="black">
        Shotguns of all gauges are allowed on the Shotgun facility grounds, as approved by the Shotgun directors.
      </Text>

      <Heading as="h2" size="md" mb={3} color="black">How do I join Golden Gun Club?</Heading>
      <Text mb={6} color="black">
        Please consult the Membership section of the website. Golden Gun Club considers memberships on a rolling/pro-rated basis, and will accept properly filed applications per the directions on this site. Please note that an active NRA membership is still a requirement for application to Golden Gun Club.
      </Text>

      <Heading as="h2" size="md" mb={3} color="black">Is private instruction available or allowed on Golden Gun Club facilities?</Heading>
      <Text mb={6} color="black">
        Please consult our Membership Bylaws; additionally, members intending to provide instruction as part of paid activity should consult the Club's Board of Directors or Management prior to doing so. However, generally, private instruction is allowed on the club's facilities, provided that it is not disruptive to the activites of other members on the range.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">What kind of targets are allowed on the Gun Club ranges?</Heading>
      <Text mb={4} color="black">We do not allow any of the following:</Text>
      <UnorderedList spacing={2} ml={6} mb={6}>
        <ListItem>exploding or incendiary targets</ListItem>
        <ListItem>Bottles, jugs, or other fragmenting targets which are hard to clean up (clay pigeons are acceptable)</ListItem>
        <ListItem>Offensive or other political targets are discouraged to avoid unwanted negative attention to the club.</ListItem>
      </UnorderedList>
      <Text mb={6} color="black">
        Steel targets are allowed under the rules laid out in the Range Rules, provided they are set at the explained minimum distances. Any steel targets causing fragmentation concerns on the shooting line will be required to be taken down at the direction of the Range Safety Officer.
      </Text>

      <Box mt={8}>
        <Text mb={4} fontWeight="bold" color="black">{contact.heading}</Text>
        <VStack align="flex-start">
          <Box color="black">{contact.address}</Box>
          <Box color="black">{contact.phoneOne}<br />{contact.phoneTwo}</Box>
          <Box><Link href={`mailto:${contact.email}`} color="blue.500">{contact.email}</Link></Box>
        </VStack>
      </Box>
    </Box>
  )
}